import { WSPage } from "@wingspanhq/fe-component-library";
import { FrequencyAndScheduleStatus } from "@wingspanhq/payments/dist/interfaces";
import { useMemo } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import { INVOICING_PATH } from "../..";
import { useBrowserPageTitle } from "../../../../shared/hooks/useBrowserPageTitle";
import { DashboardTabs } from "../../components/DashboardTabs";
import { PageToolarProps, PageToolbar } from "../../components/PageToolbar";
import { useQueryInvoiceTemplateRowsSummary } from "../../queries/useQueryInvoiceTemplateRowsSummary";
import { RouteDeposited } from "./routes/RouteDeposited";
import { RouteDrafts } from "./routes/RouteDrafts";
import { RouteInProgress } from "./routes/RouteInProgress";
import { RouteIndex } from "./routes/RouteIndex";
import { RouteOutstanding } from "./routes/RouteOutstanding";

export const RouteDashboard: React.FC = () => {
  useBrowserPageTitle("Invoicing");
  const history = useHistory();
  const queryInvoiceTemplateRowsSummary = useQueryInvoiceTemplateRowsSummary({
    filter: {
      status: {
        in: [
          FrequencyAndScheduleStatus.Active,
          FrequencyAndScheduleStatus.Draft
        ]
      }
    }
  });

  const showManageSeries = useMemo(
    () => !!queryInvoiceTemplateRowsSummary.data?.listSize,
    [queryInvoiceTemplateRowsSummary.data?.listSize]
  );

  const pageButtons = useMemo(() => {
    const buttons: PageToolarProps["buttons"] = [
      {
        label: "Create invoice",
        onClick: () => history.push(INVOICING_PATH + "/create")
      }
    ];

    if (showManageSeries) {
      buttons.unshift({
        kind: "Tertiary",
        label: "Scheduled invoices",
        onClick: () => history.push(INVOICING_PATH + "/scheduled")
      });
    }

    return buttons;
  }, [history, showManageSeries]);

  return (
    <WSPage>
      <PageToolbar
        title="Invoicing"
        buttons={pageButtons}
        mb="2XL"
        showSearch
      />

      {/* <PaymentsStatusBanner mb="L" /> */}

      <DashboardTabs mb="L" />

      <Switch>
        <Route path={INVOICING_PATH + "/drafts"} component={RouteDrafts} />
        <Route
          path={INVOICING_PATH + "/outstanding"}
          component={RouteOutstanding}
        />
        <Route
          path={INVOICING_PATH + "/in-progress"}
          component={RouteInProgress}
        />
        <Route
          path={INVOICING_PATH + "/deposited"}
          component={RouteDeposited}
        />
        <Route path={INVOICING_PATH} component={RouteIndex} />
      </Switch>
    </WSPage>
  );
};
